const drillDownTitle = 'Halo Factor Ratings';

export default drillDownTitle;
